<template>
  <div class="companyInfoContainer">
    <!-- 主卡片容器 -->
    <div class="companyCard">
      <!-- 头部区域 -->
      <div class="companyCardHeader">
        <div class="headerLeft">
          <div class="headerIconBox">
            <i class="el-icon-office-building"></i>
          </div>
          <div class="headerTitleGroup">
            <div class="titleRow">
              <h2 class="companyCardTitle">企业基本信息</h2>
              <!-- <span
                class="statusBadge"
                :class="{ 'is-completed': isCompleted }"
              >
                <i
                  :class="
                    isCompleted ? 'el-icon-success' : 'el-icon-warning-outline'
                  "
                ></i>
                {{ isCompleted ? "信息已完善" : "待完善信息" }}
              </span> -->
            </div>
          </div>
        </div>

        <el-button
          v-if="!isEditMode && isCompleted"
          type="primary"
          size="medium"
          icon="el-icon-edit"
          class="editModeBtn"
          @click="isEditMode = true"
        >
          编辑信息
        </el-button>
      </div>

      <div class="cardDivider"></div>

      <!-- 表单与数据展示主体 -->
      <el-form
        ref="companyForm"
        :model="form"
        :rules="formRules"
        label-position="top"
        :hide-required-asterisk="!isEditMode"
        class="companyFormBody"
      >
        <!-- 展示模式：卡片网格 (Read-Only Info Grid) -->
        <div v-if="!isEditMode" class="infoTileGrid">
          <div v-for="item in fieldList" :key="item.key" class="infoTile">
            <div class="tileIconWrap">
              <i :class="item.icon"></i>
            </div>
            <div class="tileMain">
              <div class="tileLabel">{{ item.label }}</div>
              <div
                class="tileValue"
                :class="{ 'is-empty': !getFieldValue(item.key) }"
              >
                {{ getFieldValue(item.key) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 编辑模式：双列表单 (Edit Form Grid) -->
        <el-row v-else :gutter="28" class="formEditRow">
          <el-col
            v-for="item in fieldList"
            :key="item.key"
            :span="12"
            :xs="24"
            :sm="12"
          >
            <el-form-item :prop="item.key">
              <template slot="label">
                <span class="customFormLabel">
                  <i :class="item.icon" class="labelIcon"></i>
                  {{ item.label }}
                </span>
              </template>

              <!-- 人员数量下拉框 -->
              <el-select
                v-if="item.isSelect"
                v-model="form[item.key]"
                :placeholder="item.placeholder"
                class="formControl"
              >
                <el-option
                  v-for="opt in staffCountOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>

              <!-- 输入框 -->
              <el-input
                v-else
                v-model="form[item.key]"
                :placeholder="item.placeholder"
                :maxlength="item.maxlength"
                clearable
                class="formControl"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 编辑模式下的操作按钮区域 -->
        <div v-if="isEditMode" class="formFooterActions">
          <el-button
            type="primary"
            class="saveBtn"
            :loading="submitting"
            icon="el-icon-check"
            @click="handleSubmit"
          >
            保存信息
          </el-button>
          <el-button
            v-if="isCompleted"
            class="cancelBtn"
            icon="el-icon-close"
            @click="handleCancel"
          >
            取消编辑
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { STAFF_COUNT_OPTIONS } from "@/common/enum";

export default {
  name: "CompanyInfoForm",
  props: {
    /** 企业信息数据对象 */
    company: {
      type: Object,
      default: () => ({}),
    },
    /** 企业信息是否完善 */
    isCompleted: {
      type: Boolean,
      default: true,
    },
    /** 是否默认进入编辑模式 */
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 是否提交中 */
      submitting: false,
      /** 当前是否处于编辑模式 */
      isEditMode: false,
      /** 人员数量下拉筛选项 */
      staffCountOptions: STAFF_COUNT_OPTIONS,
      /** 字段配置列表（统一管理 Icon、Label 及对应校验属性） */
      fieldList: [
        {
          key: "decisionMaker",
          label: "负责人/决策人",
          icon: "el-icon-user",
          placeholder: "请输入负责人/决策人姓名",
          maxlength: 50,
        },
        {
          key: "decisionMakerPhone",
          label: "负责人联系方式",
          icon: "el-icon-mobile-phone",
          placeholder: "请输入负责人联系手机号",
          maxlength: 20,
        },
        {
          key: "businessAddress",
          label: "公司经营地址",
          icon: "el-icon-location-outline",
          placeholder: "请输入公司详细经营地址",
          maxlength: 200,
        },
        {
          key: "cabinetType",
          label: "生产的盘柜类型",
          icon: "el-icon-box",
          placeholder: "如：高压开关柜、低压配电柜等",
          maxlength: 100,
        },
        {
          key: "mainIndustry",
          label: "主要行业",
          icon: "el-icon-office-building",
          placeholder: "如：电力、新能源、建筑、工业等",
          maxlength: 100,
        },
        {
          key: "mainCustomer",
          label: "主要客户",
          icon: "el-icon-s-custom",
          placeholder: "请输入核心合作客户名称",
          maxlength: 100,
        },
        {
          key: "staffCount",
          label: "人员数量",
          icon: "el-icon-pie-chart",
          isSelect: true,
          placeholder: "请选择公司人员规模",
        },
        {
          key: "competitorCooperation",
          label: "友商合作情况",
          icon: "el-icon-connection",
          placeholder: "请输入友商合作品牌或情况",
          maxlength: 200,
        },
      ],
      /** 表单绑定的值对象 */
      form: {
        decisionMaker: "",
        decisionMakerPhone: "",
        businessAddress: "",
        cabinetType: "",
        mainIndustry: "",
        mainCustomer: "",
        staffCount: "",
        competitorCooperation: "",
      },
      /** 表单校验规则 */
      rules: {
        decisionMaker: [
          { required: true, message: "请输入负责人/决策人", trigger: "blur" },
        ],
        decisionMakerPhone: [
          { required: true, message: "请输入负责人联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        businessAddress: [
          { required: true, message: "请输入公司经营地址", trigger: "blur" },
        ],
        cabinetType: [
          { required: true, message: "请输入生产的盘柜类型", trigger: "blur" },
        ],
        mainIndustry: [
          { required: true, message: "请输入主要行业", trigger: "blur" },
        ],
        mainCustomer: [
          { required: true, message: "请输入主要客户", trigger: "blur" },
        ],
        staffCount: [
          { required: true, message: "请选择人员数量", trigger: "change" },
        ],
        competitorCooperation: [
          { required: true, message: "请输入友商合作情况", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    /** 获得人员数量对应的文案说明 */
    staffCountLabel() {
      const option = this.staffCountOptions.find(
        (item) => item.value === this.form.staffCount
      );
      return option ? option.label : this.form.staffCount;
    },
    /** 根据编辑状态切换校验规则 */
    formRules() {
      return this.isEditMode ? this.rules : {};
    },
  },
  watch: {
    isCompleted: {
      handler(val) {
        if (!val) {
          this.isEditMode = true;
        }
      },
      immediate: true,
    },
    isEdit: {
      handler(val) {
        this.isEditMode = !this.isCompleted ? true : val;
      },
      immediate: true,
    },
    company: {
      handler(val) {
        this.fillFormFromCompany(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 获取指定字段在展示模式下的文本值
     * @param {string} key - 字段名
     * @returns {string} 替换为对应的 label 或 '-'
     */
    getFieldValue(key) {
      if (key === "staffCount") {
        return this.staffCountLabel || "-";
      }
      const val = this.form[key];
      return val !== undefined && val !== null && val !== "" ? val : "-";
    },
    /**
     * 从后端 company 数据填充表单
     * @param {Object} company - 企业数据
     */
    fillFormFromCompany(company) {
      if (
        !company ||
        typeof company !== "object" ||
        Object.keys(company).length === 0
      ) {
        return;
      }
      this.form = {
        decisionMaker: company.decisionMaker || this.form.decisionMaker || "",
        decisionMakerPhone:
          company.decisionMakerPhone || this.form.decisionMakerPhone || "",
        businessAddress:
          company.businessAddress || company.companyAddress || "",
        cabinetType: company.cabinetType || this.form.cabinetType || "",
        mainIndustry: company.mainIndustry || this.form.mainIndustry || "",
        mainCustomer: company.mainCustomer || this.form.mainCustomer || "",
        staffCount: (() => {
          const val =
            company.staffCount !== undefined &&
            company.staffCount !== null &&
            company.staffCount !== ""
              ? isNaN(company.staffCount)
                ? company.staffCount
                : Number(company.staffCount)
              : company.personnelNum || this.form.staffCount || "";
          return val == 0 ? "" : val;
        })(),
        competitorCooperation:
          company.competitorCooperation ||
          this.form.competitorCooperation ||
          "",
      };
    },
    /** 提交表单保存 */
    handleSubmit() {
      this.$refs.companyForm.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$emit("submit", { ...this.form });
        this.submitting = false;
      });
    },
    /** 取消编辑 */
    handleCancel() {
      this.isEditMode = false;
      this.fillFormFromCompany(this.company);
    },
    /** 重置表单校验与值 */
    resetForm() {
      this.$refs.companyForm && this.$refs.companyForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.companyInfoContainer {
  padding: 10px 0 20px;
}

/* 主卡片外观与布局 */
.companyCard {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 22, 26, 0.05);
  border: 1px solid #eef3f6;
  padding: 32px 36px 40px;
  transition: all 0.3s ease;
}

/* 卡片头部 */
.companyCardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 16px;
}

.headerIconBox {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(0, 216, 195, 0.15) 0%,
    rgba(0, 216, 195, 0.05) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00d8c3;
  font-size: 24px;
}

.headerTitleGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.companyCardTitle {
  margin: 0;
  font-family: PingFangSC, PingFang SC, sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #00161a;
  line-height: 28px;
}

/* 状态标签 */
.statusBadge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: #fffbe6;
  color: #faad14;
  border: 1px solid #ffe58f;

  &.is-completed {
    background: #e6f7ff;
    color: #1890ff;
    border-color: #91d5ff;
  }
}

.companyCardSubtitle {
  margin: 0;
  font-size: 13px;
  color: #8c9ea8;
}

/* 编辑按钮 */
.editModeBtn {
  background: linear-gradient(135deg, #00d8c3 0%, #00c2b0 100%);
  border: none;
  color: #ffffff;
  height: 38px;
  padding: 0 22px;
  border-radius: 20px;
  font-weight: 500;

  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover,
  &:focus {
    background: linear-gradient(135deg, #00e6d0 0%, #00b3a2 100%);

    transform: translateY(-1px);
    color: #ffffff;
  }
}

.cardDivider {
  height: 1px;
  background: #f0f4f7;
  margin: 24px 0 28px;
}

.companyFormBody {
  margin: 0;
}

/* 展示模式：网格卡片 (Read-Only Tile Grid) */
.infoTileGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 24px;
}

.infoTile {
  background: #f8fafc;
  border: 1px solid #f0f4f7;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.25s ease;

  &:hover {
    background: #ffffff;
    border-color: #d1f2ee;
    box-shadow: 0 6px 18px rgba(0, 216, 195, 0.08);
    transform: translateY(-2px);

    .tileIconWrap {
      background: #00d8c3;
      color: #ffffff;
      transform: scale(1.05);
    }
  }
}

.tileIconWrap {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #eef9f8;
  color: #00d8c3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.tileMain {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.tileLabel {
  font-size: 13px;
  color: #7a8b94;
}

.tileValue {
  font-size: 15px;
  font-weight: 500;
  color: #1a252c;
  line-height: 22px;
  word-break: break-all;

  &.is-empty {
    color: #b0bec5;
    font-weight: normal;
  }
}

/* 编辑模式：双列表单 */
.formEditRow {
  margin-bottom: 10px;
}

.customFormLabel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #4a5a64;

  .labelIcon {
    color: #00d8c3;
    font-size: 16px;
  }
}

.formControl {
  width: 100%;
}

/deep/ .el-form-item {
  margin-bottom: 24px;
}

/deep/ .el-form-item__label {
  padding-bottom: 6px !important;
  line-height: 1.4 !important;
}

/deep/ .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 0 14px;
  font-size: 14px;
  transition: all 0.25s ease;

  &:hover {
    border-color: #00d8c3;
  }

  &:focus {
    border-color: #00d8c3;
    box-shadow: 0 0 0 3px rgba(0, 216, 195, 0.15);
  }
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #00d8c3;
  box-shadow: 0 0 0 3px rgba(0, 216, 195, 0.15);
}

/* 底部按钮栏 */
.formFooterActions {
  margin-top: 36px;
  padding-top: 24px;
  border-top: 1px dashed #eef3f6;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.saveBtn {
  min-width: 150px;
  height: 42px;
  border-radius: 8px;
  background: linear-gradient(135deg, #00d8c3 0%, #00c2b0 100%);
  border: none;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 4px 14px rgba(0, 216, 195, 0.3);
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background: linear-gradient(135deg, #00e6d0 0%, #00b3a2 100%);
    box-shadow: 0 6px 18px rgba(0, 216, 195, 0.42);
    transform: translateY(-1px);
  }
}

.cancelBtn {
  min-width: 150px;
  height: 42px;
  border-radius: 8px;
  border-color: #d0d9de;
  color: #525f66;
  font-size: 15px;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    border-color: #00d8c3;
    color: #00d8c3;
    background-color: #eef9f8;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .infoTileGrid {
    grid-template-columns: 1fr;
  }

  .companyCard {
    padding: 20px 18px 24px;
  }

  .companyCardHeader {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .editModeBtn {
    align-self: flex-end;
  }
}
</style>

